"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _withIconProps = require("../utils/withIconProps");
var _react2 = require("@emotion/react");
/**
 * This file generated by Stencil generateIcons scripts
 * DO NOT EDIT DIRECTLY
 */

const IconDisabledSmall = (0, _withIconProps.withIconProps)(props => {
  return (0, _react2.jsx)("svg", (0, _extends2.default)({
    width: "20px",
    height: "20px",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), (0, _react2.jsx)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10ZM17 10C17 13.866 13.866 17 10 17C8.42766 17 6.97641 16.4816 5.80783 15.6064L15.6064 5.80783C16.4816 6.97641 17 8.42766 17 10ZM4.39362 14.1922L14.1922 4.39362C13.0236 3.5184 11.5723 3 10 3C6.13401 3 3 6.13401 3 10C3 11.5723 3.5184 13.0236 4.39362 14.1922Z",
    fill: "currentColor"
  }));
}, 'IconDisabledSmall');
IconDisabledSmall.displayName = 'IconDisabledSmall';
var _default = exports.default = IconDisabledSmall;